import { render, staticRenderFns } from "./CommonPostSettings.vue?vue&type=template&id=7e87d915&"
import script from "./CommonPostSettings.vue?vue&type=script&lang=ts&"
export * from "./CommonPostSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports